import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcArrowForward = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	...props,
	children: [/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("path", {
		id: "a",
		d: "M12.652 6.169H3.344L7.41 2.102a.84.84 0 0 0 0-1.183.83.83 0 0 0-1.175 0L.744 6.41a.83.83 0 0 0 0 1.175l5.491 5.492a.83.83 0 1 0 1.175-1.175L3.344 7.835h9.308a.836.836 0 0 0 .833-.833.836.836 0 0 0-.833-.833z"
	}) }), /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		fillRule: "evenodd",
		transform: "translate(3 3)",
		children: [/* @__PURE__ */ _jsx("mask", {
			id: "b",
			fill: "#fff",
			children: /* @__PURE__ */ _jsx("use", { xlinkHref: "#a" })
		}), /* @__PURE__ */ _jsx("use", {
			fill: "#959BA1",
			transform: "matrix(-1 0 0 1 13.985 0)",
			xlinkHref: "#a"
		})]
	})]
});
export default SvgIcArrowForward;
